<app-dialog [config]="config" (actionButtonClicked)="onActionButtonClicked($event)">
    <ng-container dialog-title>
        Onboarding in progress
    </ng-container>
    <ng-container dialog-process-in-progress>
        <p class="mb-3">This client has onboardings that can't be finished yet. View one, or start a new onboarding.</p>

        <ul class="list-unstyled onboarding-in-progress__list mb-0">
            <li *ngFor="let row of rows" class="d-flex align-items-center justify-content-between py-2">
                <span class="mr-3">{{ row.description }}</span>
                <button type="button" class="btn btn-outline-primary btn-sm" (click)="view(row.onboardingId)">
                    View progress
                </button>
            </li>
        </ul>
    </ng-container>
</app-dialog>
